/** @jsx jsx */
import type { Interpolation, Theme } from '@emotion/react';
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Accordion, AccordionGroup, AccordionHeader, AccordionPanel, Grid, Typography } from '@coursera/cds-core';

type Props = {
  faqs?: ({ question?: string | null; answer?: string | null } | null | undefined)[] | null;
  title?: string | null;
};

type FaqWithQandA = {
  question: string;
  answer: string;
};

const style: Record<string, Interpolation<Theme>> = {
  wrapper: () => css`
    max-width: 770px;
    margin: var(--cds-spacing-800) 0;
  `,
  answer: () => css`
    padding: var(--cds-spacing-100);
  `,
};

const FaqModule: React.FC<Props> = ({ title, faqs }) => {
  if (!faqs || !faqs.length) {
    return null;
  }

  const QandA = faqs
    ?.filter((faq): faq is FaqWithQandA => Boolean(faq?.question && faq?.answer))
    .map((faq) => (
      <Accordion variant="standard">
        <AccordionHeader label={faq.question} />
        <AccordionPanel css={style.answer}>{faq.answer}</AccordionPanel>
      </Accordion>
    ));

  return (
    <Grid container justifyContent="center" alignContent="center">
      <Grid container css={style.wrapper} spacing={32}>
        <Grid item container justifyContent="center">
          <Typography color="supportText" variant="h1semibold" component="h2">
            {title}
          </Typography>
        </Grid>
        <Grid item>
          <AccordionGroup>{QandA}</AccordionGroup>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FaqModule;
